var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcThinking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1339,
    height: 1163,
    viewBox: "0 0 1339 1163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1087.26 113.366C1148.51 105.483 1180.93 150.814 1189.49 174.465C1238.43 83.2091 1177.85 30.5289 1118.12 34.741C1055.93 36.5903 1030.89 17.5216 1020.76 0C1017.4 41.0734 1026 121.249 1087.26 113.366Z",
    fill: "#21325B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.93 107.886C1044.9 128.941 1032.54 164.806 1035.59 197.607M1180.22 204.495L1163.92 226.044C1142.27 261.504 1100.21 269.325 1074.03 257.922C1055.13 247.813 1044.77 233.92 1039.54 217.107",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.85 178.644C1188.1 174.445 1195.02 169.209 1196.64 181.858C1198.26 194.507 1186.39 202.093 1180.25 204.305",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.05 183.53C1190.27 184.696 1191.81 187.722 1188.28 190.503",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.3 210.401C1091.77 213.4 1090.52 215.86 1089.06 217.431C1087.59 219.027 1086.17 219.463 1085.13 219.275C1084.08 219.087 1082.9 218.188 1082.07 216.18C1081.26 214.202 1080.94 211.462 1081.47 208.462C1082.01 205.463 1083.26 203.003 1084.71 201.432C1086.19 199.836 1087.6 199.4 1088.65 199.588C1089.7 199.776 1090.87 200.675 1091.7 202.683C1092.52 204.661 1092.84 207.401 1092.3 210.401Z",
    stroke: "#21325B",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.82 231.528C1077.94 235.264 1084.14 240.623 1091.96 232.181",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.43 144.957C1096.35 151.092 1089.33 164.434 1077.92 168.714",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.1 180.217C1090.36 177.037 1084.64 170.73 1077.92 168.714",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.27 137.279C1134.42 138.038 1145.14 142.167 1146.84 152.608",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.63 134.425C1058.35 130.166 1064.16 122.174 1073.69 124.285",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1072.17,
    cy: 141.271,
    rx: 4.5,
    ry: 6,
    transform: "rotate(10.1503 1072.17 141.271)",
    fill: "#21325B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1130.23,
    cy: 160.3,
    rx: 5,
    ry: 5.5,
    transform: "rotate(10.1503 1130.23 160.3)",
    fill: "#21325B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.54 258.607C1201.83 274.486 1271.76 309.394 1307.16 365.994C1342.56 422.593 1302.93 450.421 1269.97 460.797L1205.95 480.607",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.58 254.135L1057.87 284.012M1167.09 223.283L1144.49 287.911M1042.87 279.391C1060.98 288.114 1110.39 300.959 1163.2 282.555",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.46 948.333C955.225 790.821 960.031 654.23 978.464 611.671C1041.73 658.489 1162.82 620.166 1203.85 603.607C1258.73 661.666 1211.32 972.301 1180.75 1120.36C1168.99 1139.71 1143.65 1129.77 1132.46 1122.38L1118.46 1019.56L1102.36 1109.61C1093.4 1124.66 1066.89 1121.7 1054.76 1118.34L1013.46 948.333Z",
    fill: "#21325B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M954.545 409.107C954.545 458.107 951.831 514.952 979.414 609.481C1005.84 630.729 1062.94 651.033 1200.75 603.815C1207.83 598.148 1207.4 601.435 1206.64 570.9C1205.7 532.731 1206.17 447.461 1196.25 403.607",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.94 425.607C1333.66 444.819 1349.27 505.257 1317.94 540.405C1286.6 575.554 1230.95 609.852 1207.04 622.607M1207.04 530.957L1248.1 486.077C1250.77 482.927 1255.18 474.644 1251.4 466.708",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.29 1131.09C1040.63 1131.09 1052.44 1122.64 1056.22 1118.42C1077.2 1124.21 1092.85 1119.62 1098.04 1116.61V1135.32C1085 1148.84 1044.17 1151.62 1026.45 1145.58C1015.82 1140.75 1019.58 1131.09 1029.29 1131.09Z",
    stroke: "#21325B",
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.86 1131.86C1125.17 1130.92 1133.55 1125.97 1136.82 1123.61C1151.99 1132.1 1167.96 1129.51 1174.04 1127.15V1137.76C1174.04 1144.84 1168.43 1146.61 1164.92 1147.79L1131.91 1157.82C1123.48 1159.98 1109.43 1161.94 1103.11 1152.51C1096.02 1141.91 1108.73 1133.04 1117.86 1131.86Z",
    stroke: "#21325B",
    strokeWidth: 5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.04 219.607C1057.04 207.607 1072.04 215.107 1072.54 206.107C1072.94 198.907 1063.04 198.107 1058.04 198.607C1006.84 197.807 964.045 226.107 942.545 243.107C896.545 279.479 875.212 350.274 874.545 383.607C873.212 406.94 877.245 454.107 904.045 456.107C930.845 458.107 960.823 407.607 966.045 364.607C971.268 321.607 982.093 267.507 999.405 265.107M1004.04 216.107C1016.88 215.607 1042.54 219.207 1042.54 237.607C1042.71 239.607 1041.44 243.307 1035.04 242.107M1017.04 231.107C1025.54 235.44 1041.04 246.107 1035.04 254.107C1033.88 255.774 1030.54 259.107 1026.54 259.107M1013.04 244.607C1019.88 248.274 1031.74 257.907 1024.54 267.107C1017.34 276.307 1009.21 275.607 1006.04 274.107C1002.78 272.748 997.86 269.351 999.405 265.107M1010.04 265.107C1009.71 261.774 1007.54 256.507 1001.54 262.107C1000.44 263.141 999.755 264.146 999.405 265.107",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M883.545 440.607C888.712 456.44 919.445 503.007 959.045 516.607",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M979.045 298.107C993.045 287.107 1014.94 269.207 1066.54 255.607",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03467 552.5L15.0347 569.5M23.5347 569.5V549M32.0347 569.5L44.0347 549",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M348.881 1022L292.348 1001.33C291.559 1001.04 291.035 1000.29 291.035 999.452V945.255C291.035 943.952 292.259 942.997 293.522 943.315L293.664 943.351M348.881 1022V964.5M348.881 1022L384.524 982.254C384.853 981.887 385.035 981.411 385.035 980.918V929.471M348.881 964.5L293.664 943.351M348.881 964.5L385.035 929.471M293.664 943.351L328.879 907.944C329.448 907.372 330.304 907.198 331.051 907.502L385.035 929.471",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M564.035 1031.16V1077.51C564.035 1077.99 564.209 1078.46 564.525 1078.82L590.758 1109M564.035 1031.16L590.758 1057.32M564.035 1031.16L609.545 1023.89C610.168 1023.79 610.801 1023.99 611.254 1024.43L637.035 1049.47M590.758 1109V1057.32M590.758 1109L635.41 1100.47C636.353 1100.29 637.035 1099.46 637.035 1098.5V1049.47M590.758 1057.32L637.035 1049.47",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M445.035 760.5L463.035 774.5M474.535 774.5V743M486.535 774.5L500.035 754",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M664.035 716L570.035 720",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M665.035 716L789.035 727",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M790.035 727L765.035 843",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M765.035 843L662.035 861",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M662.035 860V737",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M662.035 738L789.035 728",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M662.035 738L570.035 720",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M568.035 720L574.035 812",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M574.035 812L662.035 861",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M663.035 716V736",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 708.246,
    y: 765.881,
    width: 37.2431,
    height: 19.996,
    rx: 8.5,
    transform: "rotate(-3.53924 708.246 765.881)",
    stroke: "#21325B",
    strokeWidth: 3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M533.035 583C550.664 611.048 598.849 664.175 650.56 652.296L723.035 598.839",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M533.035 583L615.035 556",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M615.035 556C630.416 570 673.551 598 723.035 598",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M579.035 597C586.146 595.333 602.501 590 611.035 582",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M600.035 615C604.479 614 614.701 610.2 620.035 603",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M624.035 628C629.701 627 644.635 622.4 651.035 608",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M661.315 887L571.535 813.5L661.535 863.5L767.535 845L777.535 846.5L661.315 887Z",
    fill: "#21325B",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcThinking);
export default __webpack_public_path__ + "static/media/oc-thinking.7b02e6c6bb5ec74ae9495c200bd85870.svg";
export { ForwardRef as ReactComponent };